import { ReactNode } from 'react';

import UserContext, { UserContextValue } from './userContext';

const UserProvider = ({ value, children }: { value: UserContextValue; children: ReactNode }) => {
	return <UserContext value={value}>{children}</UserContext>;
};

export default UserProvider;
